"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPalette = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./FluentColors"), exports);
var DefaultPalette_1 = require("./DefaultPalette");
Object.defineProperty(exports, "DefaultPalette", { enumerable: true, get: function () { return DefaultPalette_1.DefaultPalette; } });
//# sourceMappingURL=index.js.map